/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Upload_BusyInputs */

const cs_chat_attach_upload_busy = /** @type {(inputs: Chat_Attach_Upload_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrávání…`)
};

const en_chat_attach_upload_busy = /** @type {(inputs: Chat_Attach_Upload_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading…`)
};

/**
* | output |
* | --- |
* | "Uploading…" |
*
* @param {Chat_Attach_Upload_BusyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_upload_busy = /** @type {((inputs?: Chat_Attach_Upload_BusyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Upload_BusyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_upload_busy(inputs)
	return cs_chat_attach_upload_busy(inputs)
});